var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.487 12.179c-1.626.561-3.848.949-6.487.949s-4.861-.388-6.487-.95l3.927 4.552c.2.227.286.478.311.551.03.086.075.237.092.419l1.265 8.765a5.8 5.8 0 0 0 1.39-.985c.124-.124.201-.22.243-.283l1.42-7.537c.02-.164.06-.299.087-.379a1.63 1.63 0 0 1 .312-.55zm-3.02 5.408a.493.493 0 0 0-.09.253l-1.417 7.524c0 1.196-3.92 3.497-3.92 2.3l-1.418-9.824a.493.493 0 0 0-.089-.253L6.756 10.89C6.289 10.407 6 9.832 6 9.188 6 6.427 11.022 5 16 5s10 1.427 10 4.188c0 .644-.267 1.196-.756 1.703zm-2.695 7.558-.005.009a.055.055 0 0 1 .005-.01zm-2.366 1.586.019-.002a.074.074 0 0 1-.019.002zM7.444 9.165c0 1.104 3.334 2.692 8.556 2.692s8.556-1.588 8.556-2.692c0-1.105-3.334-2.692-8.556-2.692S7.444 8.06 7.444 9.165z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLight);
export default __webpack_public_path__ + "static/media/Filter-Light.c65a07f0a6eedbcb8f8c109f65bddc15.svg";
export { ForwardRef as ReactComponent };